export const REQUEST_STATUS_LABELS = {
  PENDING: "Pending",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  APPLIED: "Applied",
  CANCELLED: "Cancelled",
  EXPIRED: "Expired",
};

export const REQUEST_STATUS_COLORS = {
  PENDING: "warning",
  APPROVED: "info",
  REJECTED: "error",
  APPLIED: "success",
  CANCELLED: "default",
  EXPIRED: "default",
};

export const AUDIT_ACTION_LABELS = {
  CREATE: "Created",
  UPDATE: "Updated",
  DELETE: "Deleted",
  VOID: "Voided",
  PROPOSED: "Proposed",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  APPLIED: "Applied",
  CANCELLED: "Cancelled",
};

export const POLICY_ROLES = [
  { value: "manager", label: "Property manager" },
  { value: "relationship_manager", label: "Relationship manager" },
  { value: "admin", label: "Platform admin" },
  { value: "any", label: "Any eligible approver" },
  { value: "user", label: "Specific user" },
];

export const POLICY_SCOPES = [
  { value: "organization", label: "Organization" },
  { value: "property", label: "Property (RM must be assigned)" },
];

export const INBOX_VIEWS = [
  { value: "pending_for_me", label: "Needs my action" },
  { value: "mine", label: "My submissions" },
  { value: "all", label: "All requests" },
];

export const AMOUNT_SENSITIVE_ENTITIES = [
  "landlord_payout",
  "rental_payment_custom",
  "broker_payout",
];

export const buildPolicyStepPayload = (step, order) => {
  const base = {
    order,
    role: step.role,
    required_approvals: Number(step.required_approvals) || 1,
  };
  if (step.role === "user") {
    return { ...base, user_id: Number(step.user_id) };
  }
  return { ...base, scope: step.scope || "organization" };
};

export const getPolicyRoleLabel = (role) =>
  POLICY_ROLES.find((r) => r.value === role)?.label ?? role;

export const getMakerDisplayName = (request) => {
  if (!request) return "—";
  if (request.maker_display_name) return request.maker_display_name;
  if (request.maker_user?.display_name) return request.maker_user.display_name;
  const first = request.maker_user?.first_name;
  const last = request.maker_user?.last_name;
  if (first || last) return `${first ?? ""} ${last ?? ""}`.trim();
  if (request.maker_user_id) return `User #${request.maker_user_id}`;
  return "—";
};
